import { Users } from "lucide-react";
import SeoLanding from "@/components/site/SeoLanding";

export default function ConduiteAccompagnee() {
  return (
    <SeoLanding
      testId="page-aac"
      seo={{
        title: "Conduite accompagnée (AAC) Boulogne-Billancourt · 990 € | DDSBillancourt",
        description: "Conduite accompagnée dès 15 ans à Boulogne-Billancourt : formule AAC à 990 € avec 16h de conduite, 5h de simulateur et heure d'évaluation offerte. Meilleur taux de réussite, période probatoire réduite à 2 ans, assurance jeune conducteur moins chère.",
        path: "/conduite-accompagnee",
      }}
      breadcrumbName="Conduite accompagnée"
      badge="AAC · dès 15 ans"
      badgeIcon={Users}
      h1="Conduite accompagnée (AAC) à Boulogne-Billancourt"
      intro={[
        "L'Apprentissage Anticipé de la Conduite (AAC) permet de commencer la formation dès 15 ans, d'accumuler de l'expérience avec un accompagnateur, et de passer l'examen dès 17 ans avec le meilleur taux de réussite de toutes les filières.",
        "Chez DDSBillancourt, auto-école à Boulogne-Billancourt, la formule conduite accompagnée est à 990 € — avec heure d'évaluation offerte et 5 heures sur notre simulateur pour acquérir les bons réflexes en toute sécurité.",
      ]}
      formules={[
        {
          name: "Formule Conduite accompagnée (AAC)",
          price: "990 €",
          priceNum: 990,
          highlight: true,
          features: ["Accessible dès 15 ans", "16 heures de conduite avec moniteur", "5 heures sur simulateur", "Heure d'évaluation offerte", "Code de la route en ligne", "Rendez-vous pédagogiques inclus", "Paiement en plusieurs fois"],
        },
      ]}
      sections={[
        {
          title: "Les avantages de la conduite accompagnée",
          bullets: [
            { title: "Meilleur taux de réussite", text: "environ 75 % de réussite au premier passage, contre 57 % en filière classique : l'expérience accumulée fait toute la différence." },
            { title: "Période probatoire réduite", text: "2 ans au lieu de 3 : vous récupérez vos 12 points plus vite." },
            { title: "Assurance moins chère", text: "la surprime « jeune conducteur » est réduite environ de moitié la première année, puis diminue plus rapidement." },
            { title: "Examen dès 17 ans", text: "et depuis 2024, il est possible de conduire seul dès 17 ans une fois le permis obtenu." },
            { title: "Une vraie expérience de la route", text: "au moins 3 000 km parcourus avec votre accompagnateur, dans toutes les conditions (nuit, pluie, autoroute)." },
          ],
        },
        {
          title: "Comment se déroule l'AAC ?",
          paragraphs: [
            "1. Formation initiale : après l'obtention du code, vous suivez au minimum 20 heures de formation pratique (notre formule inclut 16 h de conduite sur route + 5 h de simulateur, précédées d'une évaluation offerte).",
            "2. Rendez-vous préalable : une leçon de 2 heures avec votre accompagnateur (parent, proche…) pour lancer la phase de conduite accompagnée.",
            "3. Phase accompagnée : vous conduisez au minimum 1 an et 3 000 km avec votre accompagnateur, ponctuée de 2 rendez-vous pédagogiques avec votre moniteur DDSBillancourt.",
            "4. Examen pratique : présentable dès 17 ans, avec un dossier solide et une aisance au volant que les examinateurs remarquent immédiatement.",
          ],
        },
        {
          title: "Qui peut être accompagnateur ?",
          paragraphs: [
            "Toute personne titulaire du permis B depuis au moins 5 ans sans interruption, avec l'accord de son assureur. Plusieurs accompagnateurs sont possibles (les deux parents par exemple). Nous briefons chaque accompagnateur lors du rendez-vous préalable pour que la phase accompagnée soit efficace et sereine.",
          ],
        },
      ]}
      faq={[
        { q: "À quel âge peut-on commencer la conduite accompagnée ?", a: "Dès 15 ans pour l'inscription et la formation initiale. L'examen pratique peut être passé dès 17 ans." },
        { q: "Que comprend la formule à 990 € ?", a: "16 heures de conduite avec moniteur, 5 heures sur simulateur, l'heure d'évaluation offerte, l'accès au code en ligne et les rendez-vous pédagogiques obligatoires." },
        { q: "Faut-il une voiture équipée de doubles commandes pour l'accompagnateur ?", a: "Non : la phase accompagnée se fait sur le véhicule familial ordinaire. Il suffit de prévenir votre assureur (extension gratuite dans la plupart des contrats) et d'apposer le disque « conduite accompagnée »." },
        { q: "Que se passe-t-il si je rate l'examen ?", a: "Vous conservez le bénéfice du code (valable 5 ans) et votre expérience. Une évaluation détermine les quelques heures de renfort nécessaires — nos packs 5 leçons (325 €) et 10 leçons (620 €) sont prévus pour ça." },
      ]}
      crossLinks={[
        { to: "/permis-boite-manuelle", label: "Permis boîte manuelle" },
        { to: "/permis-boite-automatique", label: "Permis boîte automatique" },
        { to: "/code-de-la-route", label: "Code de la route" },
        { to: "/accelere", label: "Formations accélérées" },
      ]}
    />
  );
}
